import {get} from "@iflat/iflat-ui/src/api/methods";
export default {
  async getItems(params) {
    const res = await get('/companyTags', { params })
    return res.data
  },
}
